

import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Uploader from './Uploader'; // Make sure this is imported

// --- MUI IMPORTS FOR THE HEADER ---
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';

function Dashboard({ session }) {
    const navigate = useNavigate();

    const handleLogout = async () => {
        await supabase.auth.signOut();
        navigate('/login');
    };

    return (
        <Box>
            {/* --- THIS IS THE HEADER WITH YOUR WELCOME ID AND LOGOUT --- */}
            <AppBar position="static" color="default" elevation={1}>
                <Toolbar>
                    
                    {/* This stays on the LEFT */}
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Welcome, {session?.user?.email ?? 'User'}
                    </Typography>
                    
                    {/* This gets pushed to the RIGHT */}
                    <Button color="error" variant="contained" onClick={handleLogout}>
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>

            {/* --- THIS RENDERS YOUR UPLOADER COMPONENT --- */}
            <Uploader />
        </Box>
    );
}

export default Dashboard;